import { forwardRef } from "react";
import { Loader2 } from "lucide-react";

/*
  V2 Button.
    variant: primary | ghost | soft | danger
    size: sm | md | lg
    icon (Lucide), iconRight (Lucide), loading, disabled
*/
export const V2Button = forwardRef(function V2Button(
  { variant = "primary", size = "md", icon: Icon, iconRight: IconR, loading, children, className = "", ...rest },
  ref
) {
  const cls = [
    "v2-btn",
    `v2-btn-${variant}`,
    size === "sm" && "v2-btn-sm",
    size === "lg" && "v2-btn-lg",
    className,
  ].filter(Boolean).join(" ");
  return (
    <button ref={ref} className={cls} disabled={loading || rest.disabled} {...rest}>
      {loading ? <Loader2 size={14} className="v2-spin" style={{ animation: "spin 900ms linear infinite" }} />
               : (Icon && <Icon size={14} strokeWidth={2.2} />)}
      {children}
      {IconR && <IconR size={14} strokeWidth={2.2} />}
    </button>
  );
});
